import type { AppRouteModule } from '/@/router/types';
import { RoleEnum } from '/@/enums/roleEnum';
import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const system: AppRouteModule = {
  path: '/system',
  name: 'System',
  component: LAYOUT,
  redirect: '/system/area',
  meta: {
    orderNo: 5,
    icon: 'lsicon:setting-outline',
    title: t('routes.nurse.sysMgt'),
    hideChildrenInMenu: false,
    roles: [RoleEnum.SUPERADMIN, RoleEnum.ADMIN],
  },
  children: [
    {
      path: 'area',
      name: 'SystemArea',
      component: () => import('/@/views/nurse/sys-mgt/area/index.vue'),
      meta: {
        icon: 'ph:map-pin-area',
        title: t('routes.nurse.areaMgt'),
      },
    },
    {
      path: 'account',
      name: 'SystemAccount',
      component: () => import('/@/views/nurse/sys-mgt/account/index.vue'),
      meta: {
        icon: 'mdi:account-box-plus-outline',
        title: t('routes.nurse.accountMgt'),
      },
    },
  ],
};

export default system;
